module.exports = __webpack_public_path__ + "img/client23.cf60f267.svg";